import React, { useState } from 'react'
import { Modal } from 'antd'
import styled from 'styled-components';
import checkBlack from '../../assets/images/icons/checkBlack.png'
// import showBlack from '../../assets/images/icons/showBlack.png'
import { redirectToRocketPrivate, redirectToRocketDM, redirectToRocketChannel } from '../../helpers/utils';

export default function NotificationsModal(props) {
  const {
    myEmail,
    myUsername,
    show,
    closeModal,
    unreadArticles,
    articlesCount,
    readArticleClick,
    removeArticleClick,
    // recommended,
    recommendedCount,
    declineConnectionById,
    acceptConnectionById,
    // handleConnect,
    connectionsRequest,
    connectionsRequestCount,
    unreadRocketNotifications,
    unreadRocketNotificationsCount,
  } = props;

  const [tabSelected, setTabSelected] = useState(0)


  function NewsCards({ unreadArticles }) {
    return (
      <>{
        unreadArticles.map((article) => {
          return (
            <Item key={article.id}>
              <Link
                target='_blank'
                id={article.id}
                href={article.website_link}
                onClick={readArticleClick}
                key={article.id}
              >
                {article.title}
              </Link>
              <ClosseButton id={article.id} onClick={removeArticleClick}>
                x
          </ClosseButton>
            </Item>
          );
        })
      }</>)
  }

  // function RecommendedsCards({ recommended }) {
  //   return (
  //     <>{
  //       recommended.map((recommend) => {
  //         return (
  //           <Item key={recommend.id}>
  //             <Link
  //               id={recommend.id}
  //               href={`/home/${recommend.usernames[0] === myUsername ? recommend.usernames[1] : recommend.usernames[0]}`}
  //               key={recommend.id}
  //             >
  //               @{recommend.usernames[0] === myUsername ? recommend.usernames[1] : recommend.usernames[0]}
  //             </Link>
  //             <ClosseButton id={recommend.id} onClick={() => declineConnectionById(recommend.id)}>
  //               x
  //         </ClosseButton>
  //             <AcceptButton id={recommend.id} onClick={() => {
  //               handleConnect(recommend, '', myUsername, true)
  //             }}>
  //               <img src={checkBlack} alt="" style={{ width: 16, height: 16 }} />
  //             </AcceptButton>
  //           </Item>
  //         );
  //       })
  //     }</>)
  // }

  function ConnectionsRequestCards({ connectionsRequest }) {
    return (
      <>{
        connectionsRequest.map((conReq) => {
          return (
            <Item key={conReq.id}>
              <Link
                id={conReq.id}
                href={`/home/${conReq.usernames[0] === myUsername ? conReq.usernames[1] : conReq.usernames[0]}`}
                key={conReq.id}
              >
                @{conReq.usernames[0] === myUsername ? conReq.usernames[1] : conReq.usernames[0]}
              </Link>
              <ClosseButton id={conReq.id} onClick={() => declineConnectionById(conReq.id)}>
                x
              </ClosseButton>
              <AcceptButton id={conReq.id} onClick={() => acceptConnectionById(conReq.id)}>
                <img src={checkBlack} alt="" style={{ width: 16, height: 16 }} />
              </AcceptButton>
            </Item>
          );
        })
      }
    </>)
  }


  function RocketNotifications({ unreadRocketNotifications }) {
    return (
      <>{
        unreadRocketNotifications.map((rocketNotification) => {
          return (
            <Item key={rocketNotification._id}>
              <ButtonLink
                id={rocketNotification._id}
                onClick={()=>resolveRocketRedirectUrl(rocketNotification)}
                key={rocketNotification._id}
              >
                {`you have ${rocketNotification.unread} Notifications by ${rocketNotification.name}`}
              </ButtonLink>
              {/* <ClosseButton id={rocketNotification._id} onClick={() => {}}>
                x
              </ClosseButton> */}
            </Item>
          );
        })
      }
    </>)
  }

  function resolveRocketRedirectUrl(rocketNotification) {
    if(rocketNotification.t==="d"){
      redirectToRocketDM(myEmail,rocketNotification.name)
    }else if(rocketNotification.t==="p"){
      redirectToRocketPrivate(myEmail,rocketNotification.name)
    }else if(rocketNotification.t==="c"){
      redirectToRocketChannel(myEmail,rocketNotification.name)
    }
  }

  return (
    <Modal title="Notifications" footer={null} visible={show} onCancel={closeModal} width={"680px"}>
      <Container>
        <Tabs>
          <Tab active={tabSelected === 0} onClick={(e) => setTabSelected(0)}>
            <Label>
              News
              <CountBubble>
                {articlesCount}
              </CountBubble>
            </Label>
          </Tab>
          {/* <Tab active={tabSelected === 1} onClick={(e) => setTabSelected(1)}>
            <Label>
              Recommended
              <CountBubble>
                {recommendedCount}
              </CountBubble>
            </Label>
          </Tab> */}
          <Tab active={tabSelected === 2} onClick={(e) => setTabSelected(2)}>
            <Label>
              Connection Request
              <CountBubble>
                {connectionsRequestCount}
              </CountBubble>
            </Label>
          </Tab>
          <Tab active={tabSelected === 3} onClick={(e) => setTabSelected(3)}>
            <Label>
              Synapse
              <CountBubble>
                {unreadRocketNotificationsCount}
              </CountBubble>
            </Label>
          </Tab>
        </Tabs>
        {
          // tabSelected===1?
          //   <RecommendedsCards recommended={recommended}/>
          // :
          tabSelected===2?
            <ConnectionsRequestCards connectionsRequest={connectionsRequest} />
          :
          tabSelected===3?
            <RocketNotifications unreadRocketNotifications={unreadRocketNotifications} />
          :
            <NewsCards unreadArticles={unreadArticles} />
        }
      </Container>
    </Modal>
  )
}


const Container = styled.div`
  width: 100%;
  display:flex;
  flex-direction: column; 
  align-items: center;
`;
const Item = styled.div`
  width: 100%;
  display: flex;
  padding: 6px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom:6px;
`;
const Link = styled.a`
  display: flex;
  flex:1;
  padding: 10px 0;
`;
const ButtonLink = styled.button`
  display: flex;
  flex:1;
  padding: 10px 0;
  border: none;
  outline: none;
  background: none;
  color: #4183c4;
  cursor: pointer;
`;
const ClosseButton = styled.button`
  border: none;
  background-color: #FFDEDEDE;
  border-radius: 4px;
  padding: 4px 20px;
`;
const AcceptButton = styled.button`
  border: none;
  background-color: #A4E3A5DE;
  border-radius: 4px;
  padding: 4px 20px;
  margin-left: 12px;
`;


const Tabs = styled.div`
  display: flex;
  width: 550px;
  max-width: 100%;
  flex-direction: row;
  margin-bottom: 20px;
  border-bottom: 1px solid ${props => props.theme.color.gabaYellow};
  align-items: flex-end;
  height: 30px;
  justify-content: space-between;
  
`;
const Tab = styled.button`
  height: 30px;
  width: 160px;
  border:none;
  background: none;
  outline: none;
  text-align: center;
  border-bottom: ${props => props.active ? `2px solid ${props.theme.color.gabaYellow}` : '0'};
`;
const CountBubble = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: #ff4d4f;
  position: absolute;
  top: -16px;
  right: -16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
`;
const Label = styled.label`
  position: relative;
`;